import { createContext, useContextSelector } from '@fluentui/react-context-selector';
export const ToolbarContext = createContext(undefined);
const toolbarContextDefaultValue = {
  size: 'medium',
  handleToggleButton: () => null,
  handleRadio: () => null,
  vertical: false,
  checkedValues: {}
};
export const useToolbarContext_unstable = selector => useContextSelector(ToolbarContext, function () {
  let ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toolbarContextDefaultValue;
  return selector(ctx);
});